module.exports = __webpack_public_path__ + "img/02.b2e2cb05.jpg";